import type { DialogProps } from "@mui/material/Dialog";
import { useEffect } from "react";

import { Dialog as MuiDialog } from "components/core/mui";

/**
 * Modal with an effect to prevent the Intercom button obscuring it.
 *
 * #### Links
 *
 * - [https://mui.com/components/dialogs/](https://mui.com/components/dialogs/)
 */
const Dialog = ({ open, ...rest }: DialogProps) => {
  useEffect(() => {
    if (open) {
      document.body.classList.add("dialog-open");

      return () => {
        document.body.classList.remove("dialog-open");
      };
    }

    return undefined;
  }, [open]);

  return <MuiDialog open={open} {...rest} />;
};

export default Dialog;
